import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
export function prepareResults(JobScoreData: any) {
  if (!JobScoreData) return;

  const { data, score } = JobScoreData;

  const matches = Object.keys(data).reduce((obj: any, objkey) => {
    if (data[objkey] > 0) {
      obj[objkey] = data[objkey];
    }
    return obj;
  }, {});

  const nomatches = Object.keys(data).filter((key) => data[key] === 0);

  return [matches, score, nomatches];
}
const ProgressBar = ({ data }: { data: any }) => {
  const [matches, score, nomatches]: any[] = prepareResults(data)!;
  return (
    <div className="w-full max-h-[600px] my-5 mx-auto overflow-y-scroll scrollbar-w-2 scrollbar-thumb-rounded  scrollbar-track-blue-lighter">
      <h2 className="text-center sm:text-lg md:text-2xl font-bold my-6">
        Resume Score
      </h2>
      <div className="w-11/12 mx-auto max-w-[120px] max-h-[120px]">
        <CircularProgressbar
          styles={buildStyles({
            textColor: "#3190ee",
            pathColor: "#3190ee",
            backgroundColor: "#3e98c7",
          })}
          value={score}
          text={`${score}%`}
        />
      </div>
      <div className=" mt-10 lg:flex  mx-auto justify-around">
        <div className="mb-4 lg:mb-0">
          <h2 className="font-bold uppercase text-[12px]">Matched Keywords</h2>
          {Object.keys(matches).map((key) => (
            <div key={key}>
              <p className="flex text-green-400 items-center text-[14px] my-3 mx-0">
                <img
                  src="/assets/images/accept.png"
                  className="w-[15px] h-[15px] mr-[.5em] inline-block "
                />
                {key}
                <span className="text-[12px] mx-1 font-bold text-green-600">
                  x
                </span>
                <span className=" text-[12px] font-bold w-[20px] h-[20px] items-center justify-center inline-flex rounded-[100%] text-green-400 bg-green-100 ">
                  {matches[key]}
                </span>
              </p>
            </div>
          ))}
        </div>
        <div className="">
          <h2 className="font-bold uppercase text-[12px] ">Missing Keywords</h2>
          {nomatches.map((key: any) => (
            <div key={key}>
              <p className="flex items-center text-[14px] text-red-400 my-3 mx-0">
                <img
                  src="/assets/images/cross.png"
                  className="w-[15px] h-[15px] mr-[.5em] inline-block "
                />
                {key}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
